// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/docs/v1/docs.proto (package mono.docs.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ActivateRfiAdoptionRequest, ActivateRfiAdoptionResponse, ApplyDocumentOperationsRequest, ApplyDocumentOperationsResponse, BatchGetDocumentsRequest, BatchGetDocumentsResponse, CheckDocumentReadsRequest, CheckDocumentReadsResponse, CopyDocumentRequest, CopyDocumentResponse, CreateDocumentRequest, CreateDocumentResponse, CreateFolderRequest, CreateFolderResponse, DeleteDocumentRequest, DeleteDocumentResponse, DeleteFolderRequest, DeleteFolderResponse, EnsureRfiSectionDocumentRequest, EnsureRfiSectionDocumentResponse, ExportDocumentVersionRequest, ExportDocumentVersionResponse, ForceSaveDocumentRequest, ForceSaveDocumentResponse, GetDocumentAnalysisRequest, GetDocumentAnalysisResponse, GetDocumentCapabilitiesRequest, GetDocumentCapabilitiesResponse, GetDocumentContentRequest, GetDocumentContentResponse, GetDocumentRegionTextRequest, GetDocumentRegionTextResponse, GetDocumentRequest, GetDocumentResponse, GetDocumentTextRequest, GetDocumentTextResponse, GetDownloadLinkRequest, GetDownloadLinkResponse, GetEditSessionRequest, GetEditSessionResponse, GetExactPageCountRequest, GetExactPageCountResponse, GetFolderRequest, GetFolderResponse, ImportDocumentVersionRequest, ImportDocumentVersionResponse, InspectRfiAdoptionRequest, InspectRfiAdoptionResponse, LabelDocumentVersionRequest, LabelDocumentVersionResponse, ListDocumentsRequest, ListDocumentsResponse, ListFoldersRequest, ListFoldersResponse, ListVersionsRequest, ListVersionsResponse, MoveDocumentRequest, MoveDocumentResponse, PingRequest, PingResponse, PromoteDocumentVersionRequest, PromoteDocumentVersionResponse, ReadRfiSectionDocumentRequest, ReadRfiSectionDocumentResponse, RenameDocumentRequest, RenameDocumentResponse, RenameFolderRequest, RenameFolderResponse, RestoreRfiSectionDocumentRequest, RestoreRfiSectionDocumentResponse, RestoreVersionRequest, RestoreVersionResponse, SaveRfiSectionDocumentRequest, SaveRfiSectionDocumentResponse, StageRfiAdoptionRequest, StageRfiAdoptionResponse } from "./docs_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * DocumentsService manages collaboratively-editable documents backed by
 * ONLYOFFICE Document Server. The service owns metadata, storage, versioning,
 * folders, and ONLYOFFICE callback handling.
 *
 * @generated from service mono.docs.v1.DocumentsService
 */ export const DocumentsService = {
    typeName: "mono.docs.v1.DocumentsService",
    methods: {
        /**
     * Trusted coordinator only: X-Admin-Secret plus the verified adopting principal.
     * Browser approval must first resolve the owned saved shanks proposal server-side.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.StageRfiAdoption
     */ stageRfiAdoption: {
            name: "StageRfiAdoption",
            I: StageRfiAdoptionRequest,
            O: StageRfiAdoptionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.InspectRfiAdoption
     */ inspectRfiAdoption: {
            name: "InspectRfiAdoption",
            I: InspectRfiAdoptionRequest,
            O: InspectRfiAdoptionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.ActivateRfiAdoption
     */ activateRfiAdoption: {
            name: "ActivateRfiAdoption",
            I: ActivateRfiAdoptionRequest,
            O: ActivateRfiAdoptionResponse,
            kind: MethodKind.Unary
        },
        /**
     * RFI documents require response authorization, including on direct calls.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.EnsureRfiSectionDocument
     */ ensureRfiSectionDocument: {
            name: "EnsureRfiSectionDocument",
            I: EnsureRfiSectionDocumentRequest,
            O: EnsureRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.ReadRfiSectionDocument
     */ readRfiSectionDocument: {
            name: "ReadRfiSectionDocument",
            I: ReadRfiSectionDocumentRequest,
            O: ReadRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.SaveRfiSectionDocument
     */ saveRfiSectionDocument: {
            name: "SaveRfiSectionDocument",
            I: SaveRfiSectionDocumentRequest,
            O: SaveRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RestoreRfiSectionDocument
     */ restoreRfiSectionDocument: {
            name: "RestoreRfiSectionDocument",
            I: RestoreRfiSectionDocumentRequest,
            O: RestoreRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Ping is a health check RPC.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.Ping
     */ ping: {
            name: "Ping",
            I: PingRequest,
            O: PingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Document CRUD
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListDocuments
     */ listDocuments: {
            name: "ListDocuments",
            I: ListDocumentsRequest,
            O: ListDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocument
     */ getDocument: {
            name: "GetDocument",
            I: GetDocumentRequest,
            O: GetDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Internal metadata lane only (X-Admin-Secret plus forwarded principal).
     * The caller enforces proposal membership and row visibility before use.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.BatchGetDocuments
     */ batchGetDocuments: {
            name: "BatchGetDocuments",
            I: BatchGetDocumentsRequest,
            O: BatchGetDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.CreateDocument
     */ createDocument: {
            name: "CreateDocument",
            I: CreateDocumentRequest,
            O: CreateDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RenameDocument
     */ renameDocument: {
            name: "RenameDocument",
            I: RenameDocumentRequest,
            O: RenameDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.MoveDocument
     */ moveDocument: {
            name: "MoveDocument",
            I: MoveDocumentRequest,
            O: MoveDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.DeleteDocument
     */ deleteDocument: {
            name: "DeleteDocument",
            I: DeleteDocumentRequest,
            O: DeleteDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Folder management
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListFolders
     */ listFolders: {
            name: "ListFolders",
            I: ListFoldersRequest,
            O: ListFoldersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.GetFolder
     */ getFolder: {
            name: "GetFolder",
            I: GetFolderRequest,
            O: GetFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.CreateFolder
     */ createFolder: {
            name: "CreateFolder",
            I: CreateFolderRequest,
            O: CreateFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RenameFolder
     */ renameFolder: {
            name: "RenameFolder",
            I: RenameFolderRequest,
            O: RenameFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.DeleteFolder
     */ deleteFolder: {
            name: "DeleteFolder",
            I: DeleteFolderRequest,
            O: DeleteFolderResponse,
            kind: MethodKind.Unary
        },
        /**
     * Edit session — returns the signed ONLYOFFICE editor config the frontend
     * passes to <DocumentEditor>.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetEditSession
     */ getEditSession: {
            name: "GetEditSession",
            I: GetEditSessionRequest,
            O: GetEditSessionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Versioning
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ListVersions
     */ listVersions: {
            name: "ListVersions",
            I: ListVersionsRequest,
            O: ListVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.docs.v1.DocumentsService.RestoreVersion
     */ restoreVersion: {
            name: "RestoreVersion",
            I: RestoreVersionRequest,
            O: RestoreVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * ApplyDocumentOperations applies AI-proposed edit operations to a document
     * server-side, via ONLYOFFICE Document Builder, producing a new version. This
     * replaces the browser-side connector apply, which requires the paid
     * Developer Edition the community docserver does not ship.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ApplyDocumentOperations
     */ applyDocumentOperations: {
            name: "ApplyDocumentOperations",
            I: ApplyDocumentOperationsRequest,
            O: ApplyDocumentOperationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDocumentText returns the plain-text content of a document's current
     * version, extracted server-side from the stored bytes. Lets the assistant
     * read what a standalone document actually contains before editing it (so
     * edits target the real text) rather than treating it as blank.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentText
     */ getDocumentText: {
            name: "GetDocumentText",
            I: GetDocumentTextRequest,
            O: GetDocumentTextResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-01: GetDocumentAnalysis returns a DOCX version's officedoc analysis
     * (sections with anchors / words / region hashes, comments, tracked
     * revisions, stats; 30-writing-workspace.md §3.4). Stored in pangaea per
     * version at save; computed lazily (and stored) for older versions. Same
     * read check as GetDocumentText.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentAnalysis
     */ getDocumentAnalysis: {
            name: "GetDocumentAnalysis",
            I: GetDocumentAnalysisRequest,
            O: GetDocumentAnalysisResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-01: GetDocumentRegionText returns the text under the heading that
     * carries an anchor bookmark, with its word count and region hash.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentRegionText
     */ getDocumentRegionText: {
            name: "GetDocumentRegionText",
            I: GetDocumentRegionTextRequest,
            O: GetDocumentRegionTextResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-02: version metadata and response-document copies. Label / kind /
     * lock / source are stored in pangaea (DocumentVersionGatewayService,
     * REVIEW.md R5) and surface on DocumentVersion fields 8-13.
     *
     * LabelDocumentVersion names a version (kind named) or marks it review /
     * final / submitted; every such kind locks it. A locked version answers
     * FailedPrecondition "version vN is locked as <kind>"; the same label and
     * kind again is a no-op. Needs update access.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.LabelDocumentVersion
     */ labelDocumentVersion: {
            name: "LabelDocumentVersion",
            I: LabelDocumentVersionRequest,
            O: LabelDocumentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * CopyDocument creates a new document from any version of another (an
     * alternate draft). Bytes are copied server-side. operation_id replays
     * return the same document (CreateDocument's idempotency).
     *
     * @generated from rpc mono.docs.v1.DocumentsService.CopyDocument
     */ copyDocument: {
            name: "CopyDocument",
            I: CopyDocumentRequest,
            O: CopyDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * PromoteDocumentVersion writes another document's version as this
     * document's next version, with a CAS on base_version_id (Aborted with
     * RfiSectionDocumentConflict when current moved).
     *
     * @generated from rpc mono.docs.v1.DocumentsService.PromoteDocumentVersion
     */ promoteDocumentVersion: {
            name: "PromoteDocumentVersion",
            I: PromoteDocumentVersionRequest,
            O: PromoteDocumentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * ImportDocumentVersion writes uploaded bytes (same container type; 100 MB
     * cap) as the document's next version, with the same CAS.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ImportDocumentVersion
     */ importDocumentVersion: {
            name: "ImportDocumentVersion",
            I: ImportDocumentVersionRequest,
            O: ImportDocumentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-03: a short-lived (5 min) signed URL that downloads one version,
     * optionally with comments stripped (officedoc.StripComments, R-5). Needs
     * read access; the edge (zou) applies the export rule first.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDownloadLink
     */ getDownloadLink: {
            name: "GetDownloadLink",
            I: GetDownloadLinkRequest,
            O: GetDownloadLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDocumentContent returns a spreadsheet's current bytes, with the same
     * read check as GetDocumentText, so the assistant can read back the rows a
     * user edited (xlsx only; capped in size).
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentContent
     */ getDocumentContent: {
            name: "GetDocumentContent",
            I: GetDocumentContentRequest,
            O: GetDocumentContentResponse,
            kind: MethodKind.Unary
        },
        /**
     * CheckDocumentReads is the batched office-document re-check history
     * replay uses. One indexed query: owner, folder owner, or permission.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.CheckDocumentReads
     */ checkDocumentReads: {
            name: "CheckDocumentReads",
            I: CheckDocumentReadsRequest,
            O: CheckDocumentReadsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-13: exact pages of a DOCX version, measured by converting it to PDF
     * with the Document Server's ConvertService. The result is stored in the
     * version's analysis (stats.exact_pages). Needs read access.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetExactPageCount
     */ getExactPageCount: {
            name: "GetExactPageCount",
            I: GetExactPageCountRequest,
            O: GetExactPageCountResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-13: one version exported as docx (docx source), xlsx (xlsx source) or
     * pdf (either source, through ConvertService), optionally with comments
     * stripped before conversion. Service lane only (X-Admin-Secret): the edge
     * applies the export rule first. Returns a 5-minute link and, for
     * server-to-server callers (WRT-16 package, WRT-30 freeze, PRP-35), the bytes.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ExportDocumentVersion
     */ exportDocumentVersion: {
            name: "ExportDocumentVersion",
            I: ExportDocumentVersionRequest,
            O: ExportDocumentVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * OPS-14: forcesave an open editing session through the Document Server's
     * CommandService and wait for the status-6 save to be persisted, so a
     * server-side write (ApplyDocumentOperations, restore, pinning a version) runs
     * on bytes that include co-editors' unsaved text. Service lane only
     * (X-Admin-Secret); no browser route. Callers: before applying to a document
     * that may be open, call this; on SAVED or NO_CHANGES apply on the current
     * version, on NOT_OPEN apply on the stored bytes. Unavailable = could not save
     * (timeout or Document Server down); FailedPrecondition = Document Server
     * rejected the command.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.ForceSaveDocument
     */ forceSaveDocument: {
            name: "ForceSaveDocument",
            I: ForceSaveDocumentRequest,
            O: ForceSaveDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-23: what the document service does to AI edits, so the agent's prompt
     * matches reality (e.g. whether DOCX applies land as tracked changes). Service
     * lane only (X-Admin-Secret), like ForceSaveDocument; no browser route.
     *
     * @generated from rpc mono.docs.v1.DocumentsService.GetDocumentCapabilities
     */ getDocumentCapabilities: {
            name: "GetDocumentCapabilities",
            I: GetDocumentCapabilitiesRequest,
            O: GetDocumentCapabilitiesResponse,
            kind: MethodKind.Unary
        }
    }
};
